import React from "react";
import HealthCampFormPage from "../components/health-camps/HealthCampFormPage";

const HealthCampEdit = () => <HealthCampFormPage mode="edit" />;

export default HealthCampEdit;
